import { SIDEBAR_TOGGLE } from '../../constants/ActionTypes';

export const toggleSidebar = () => (dispatch) => {
  dispatch({
    type: SIDEBAR_TOGGLE,
  });
};
